import { formatNumberCoords } from '../utils/functions';
const city = [
  53.5429650189806,
  -2.219104161203631,
  53.53857859423423,
  -2.2374719285376155,
  53.544597061005085,
  -2.2512048386938655,
  53.54276100930308,
  -2.260302891672381,
  53.53653824181516,
  -2.268714299143084,
  53.524906355380715,
  -2.2639077805883967,
  53.528988082882066,
  -2.2472566270239436,
  53.51827270921443,
  -2.256183018625506,
  53.512148421514716,
  -2.2448533677466,
  53.5078608934421,
  -2.2501748704321467,
  53.50592115491337,
  -2.2458833360083186,
  53.50306243106727,
  -2.2474282884008967,
  53.503572931607984,
  -2.252063145578631,
  53.4997950820272,
  -2.2553247117407405,
  53.48815310448369,
  -2.2484582566626155,
  53.48631460532679,
  -2.243995060861834,
  53.47661009514206,
  -2.263049473703631,
  53.469662345705174,
  -2.2692292832739436,
  53.46230466529997,
  -2.2578996323950373,
  53.46302005130638,
  -2.252063145578631,
  53.46056724909698,
  -2.2527497910864436,
  53.45913638236697,
  -2.2578996323950373,
  53.45075462314474,
  -2.272662510813006,
  53.44963011496071,
  -2.286567082346209,
  53.44380264115632,
  -2.2942918443091,
  53.4409109642296,
  -2.289142003000506,
  53.43896816308078,
  -2.2900003098852717,
  53.43835462847284,
  -2.293433537424334,
  53.43630944913235,
  -2.2942918443091,
  53.43692301326991,
  -2.2996133469946467,
  53.433139226624625,
  -2.2997850083716,
  53.431093796274524,
  -2.287768711984881,
  53.42454775763413,
  -2.2831338548071467,
  53.421785845235306,
  -2.2733491563208186,
  53.41881914688195,
  -2.276782383859881,
  53.418921450270965,
  -2.279357304514178,
  53.41472680949355,
  -2.2784989976294123,
  53.41411292491842,
  -2.286223759592303,
  53.40858756498599,
  -2.2978967332251155,
  53.40705261539869,
  -2.298261695137007,
  53.40961083394133,
  -2.302209906806929,
  53.41032710756395,
  -2.313024573554976,
  53.411657298006325,
  -2.3193760445022416,
  53.39753469170808,
  -2.307874732246382,
  53.396715846128664,
  -2.3044415047073197,
  53.38432888529811,
  -2.300493293037398,
  53.37675161215356,
  -2.285730414619429,
  53.36311054598101,
  -2.295515113105757,
  53.35932019021941,
  -2.2999783089065384,
  53.3568614007981,
  -2.314741187324507,
  53.34487277078052,
  -2.2972317268752884,
  53.34149075268862,
  -2.3028965523147416,
  53.340670829117165,
  -2.3013515999221634,
  53.342618121857974,
  -2.296373419990523,
  53.34036335371341,
  -2.2888203194045853,
  53.34415539541896,
  -2.279893927803023,
  53.34948418134216,
  -2.267705970039351,
  53.352968027416914,
  -2.2642727425002884,
  53.35747611145293,
  -2.2574062874221634,
  53.359627528922516,
  -2.2586079170608353,
  53.36044708796101,
  -2.2407551338577103,
  53.37024815003275,
  -2.236572264353225,
  53.37306991194308,
  -2.2403488146461936,
  53.387405395313365,
  -2.2427520739235374,
  53.38761015296929,
  -2.2458419787086936,
  53.39446896534071,
  -2.2439537035622092,
  53.39624911839293,
  -2.2453505282912323,
  53.397666261793304,
  -2.2427756076369354,
  53.40022504476729,
  -2.2386557345900604,
  53.40114616897255,
  -2.2220045810256073,
  53.40523981308027,
  -2.2192579989943573,
  53.40646782950849,
  -2.2125632052931854,
  53.410356314346764,
  -2.2166830783400604,
  53.41915525705129,
  -2.213249850800998,
  53.4186437404576,
  -2.208100009492404,
  53.42785009772996,
  -2.1974570041213104,
  53.42723640259926,
  -2.1938521152052948,
  53.434804690022915,
  -2.191448855927951,
  53.43449789376888,
  -2.176514316133029,
  53.447892600423735,
  -2.1727377658400604,
  53.449426076020686,
  -2.1670729404006073,
  53.453715787604104,
  -2.1664283127323025,
  53.451875796094,
  -2.161621794177615,
  53.45872441879654,
  -2.149948536228692,
  53.46363009443175,
  -2.1537250865216606,
  53.46833083503623,
  -2.147545276951348,
  53.4724180124407,
  -2.148720775412518,
  53.475278802440855,
  -2.154042278098065,
  53.48018256520183,
  -2.1614237173070494,
  53.48858572052225,
  -2.1673602743181064,
  53.4915475491182,
  -2.1647853536638095,
  53.498283770827236,
  -2.1598112149747495,
  53.49950909990417,
  -2.1651327176602964,
  53.502878572272785,
  -2.1738874478849057,
  53.50634986977374,
  -2.176977352670062,
  53.51247499546015,
  -2.1749174161466245,
  53.512985382643656,
  -2.160497860482562,
  53.51849717254089,
  -2.155004696420062,
  53.52217130082932,
  -2.1586095853360776,
  53.52033427651501,
  -2.1653043790372495,
  53.52462054266907,
  -2.1752607389005307,
  53.52727372819149,
  -2.175432400277484,
  53.53268545146598,
  -2.206423386525702,
  53.53621784697643,
  -2.206247375187338,
  53.53999961631529,
  -2.211817461310719,
];

export const cityAreaCoords = formatNumberCoords(city);
